export default {
    paginator: {
        perPage: 10,
    },
    gatewaysCommissions: {
        mercadopago: 6,
        paypal: 6,
        bankTransfer: 3.5
    },
}